/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Text, VFlow } from 'bold-ui'
import { resolveName, SimNaoEnum } from 'components/form'
import { SimNaoSwitchButtonField } from 'components/form/field/SimNaoSwitchButtonField'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { isEmpty } from 'lodash'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoArrowDown } from '../../components/ConsultaSeguimentoArrowDown'
import { ConsultaSeguimentoIndicatorResultado } from '../../components/ConsultaSeguimentoIndicatorResultado'
import { ConsultaSeguimentoIndicatorStart } from '../../components/ConsultaSeguimentoIndicatorStart'
import { ConsultaSeguimentoPerguntaHeader } from '../../components/ConsultaSeguimentoPerguntaHeader'
import { ConsultaSeguimentoPerguntaHeaderTitle } from '../../components/ConsultaSeguimentoPerguntaHeaderTitle'
import { PerguntaSimNaoRadioGroupBoxField } from '../../components/PerguntaSimNaoRadioGroupBoxField'
import { useConsultaSeguimentoSetResultado } from '../../hooks/useConsultaSeguimentoSetResultado'
import { PassouFalhouEnum } from '../../model-consultaSeguimento'
import { ConsultaSeguimentoPergunta19Model } from './model-consultaSeguimentoPergunta19'

interface ConsultaSeguimentoPergunta19FieldProps {
  name: MetaPath<ConsultaSeguimentoPergunta19Model>
}

export function ConsultaSeguimentoPergunta19Field(props: Readonly<ConsultaSeguimentoPergunta19FieldProps>) {
  const { name } = props

  const {
    input: { value },
  } = useField<ConsultaSeguimentoPergunta19Model>(resolveName(name), {
    subscription: { value: true },
  })

  useConsultaSeguimentoSetResultado<ConsultaSeguimentoPergunta19Model>({
    name,
    conditionToCalculate,
    calculateResultado,
  })

  return (
    <VFlow vSpacing={0}>
      <VFlow>
        <ConsultaSeguimentoPerguntaHeader
          pergunta={MChatPerguntaEnum.PERGUNTA_19}
          title={
            <ConsultaSeguimentoPerguntaHeaderTitle
              prefix='Se acontecer alguma coisa nova,'
              sufix=' olha para o seu rosto para ver como você se sente sobre isso?'
            />
          }
          status={value.status}
          field={<SimNaoSwitchButtonField name={name.PERGUNTA_19_HEADER} />}
        />
        {value.PERGUNTA_19_HEADER === SimNaoEnum.NAO && (
          <VFlow vSpacing={0}>
            <ConsultaSeguimentoIndicatorStart />
            <PerguntaSimNaoRadioGroupBoxField
              name={name.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO}
              label={
                <Text color='inherit'>
                  Se o seu filho ouve um barulho estranho ou assustador, ele olha para você, <u>antes</u> de responder?
                </Text>
              }
              required
            />
            {value.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO === SimNaoEnum.NAO && (
              <VFlow vSpacing={0}>
                <ConsultaSeguimentoArrowDown />
                <PerguntaSimNaoRadioGroupBoxField
                  name={name.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA}
                  label={
                    <Text color='inherit'>
                      O seu filho <u>olha para você</u> quando uma pessoa estranha se aproxima?
                    </Text>
                  }
                  required
                />
                {value.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA === SimNaoEnum.NAO && (
                  <VFlow vSpacing={0}>
                    <ConsultaSeguimentoArrowDown />
                    <PerguntaSimNaoRadioGroupBoxField
                      name={name.PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO}
                      label={
                        <Text color='inherit'>
                          Seu filho <u>olha para você</u> quando ele vê algo não familiar ou que dá um pouco de medo?
                        </Text>
                      }
                      required
                    />
                  </VFlow>
                )}
              </VFlow>
            )}
          </VFlow>
        )}
      </VFlow>
      {value.resultado && <ConsultaSeguimentoIndicatorResultado resultado={value.resultado} />}
    </VFlow>
  )
}

const conditionToCalculate = (values: ConsultaSeguimentoPergunta19Model): boolean => {
  return (
    values.PERGUNTA_19_HEADER === SimNaoEnum.SIM ||
    values.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO === SimNaoEnum.SIM ||
    values.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA === SimNaoEnum.SIM ||
    !isEmpty(values.PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO)
  )
}

const calculateResultado = (values: ConsultaSeguimentoPergunta19Model): PassouFalhouEnum => {
  if (
    values.PERGUNTA_19_HEADER === SimNaoEnum.SIM ||
    values.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO === SimNaoEnum.SIM ||
    values.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA === SimNaoEnum.SIM ||
    values.PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO === SimNaoEnum.SIM
  ) {
    return PassouFalhouEnum.PASSOU
  }
  return PassouFalhouEnum.FALHOU
}
